import styled from 'styled-components';

export const RightBlockMainWrap = styled.div(
  props => `
        width: 73%;
        display: flex;
        @media (max-width: 768px){
            width:100%;
            max-width:90%;
            margin: 1.5rem auto;
        }
    `,
);

export const RightBackdrop = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 15;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.8);
`;

export const RightInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `,
);
